/**
 * Fields React Flow writes onto a node or an edge while it renders it and while the user points at
 * it. None of them is the user's work, and the stored copy is seeded without `measured`
 * (`hydrateCampaignGraph`), so a comparison that kept them read a measurement or a click as an
 * unsaved edit: "Save and leave" saved, was told the canvas was still unsaved, and kept the user in
 * the builder (PREC-4433).
 */
const RENDER_NODE_FIELDS: readonly string[] = ["measured", "selected", "dragging", "resizing"];
const RENDER_NODE_DATA_FIELDS: readonly string[] = ["inmailSenderMissing"];
const RENDER_EDGE_FIELDS: readonly string[] = ["selected"];

const withoutFields = (item: unknown, fields: readonly string[]) =>
	item !== null && typeof item === "object"
		? Object.fromEntries(Object.entries(item).filter(([key]) => !fields.includes(key)))
		: item;

/** Sender capability is derived during rendering, including while settings owns the pause. */
const withoutNodeDecorations = (item: unknown) => {
	const node = withoutFields(item, RENDER_NODE_FIELDS);

	return node !== null && typeof node === "object" && "data" in node
		? { ...node, data: withoutFields(node.data, RENDER_NODE_DATA_FIELDS) }
		: node;
};

/** The canvas as the user edited it, serialized so one state can be compared with another. */
export function canvasSnapshot(
	nodes: readonly unknown[],
	edges: readonly unknown[],
	isValid: boolean
): string {
	return JSON.stringify({
		nodes: nodes.map(withoutNodeDecorations),
		edges: edges.map((edge) => withoutFields(edge, RENDER_EDGE_FIELDS)),
		isValid,
	});
}
